<style lang="sass" scoped>
.charge
    padding: 20px
    .home-fee
        height: 120px
        padding: 20px
        border-radius: 10px
        margin-bottom: 20px
        background: linear-gradient(135deg,rgba(216,202,154,0.5) 0%,rgba(196,171,130,0.5) 100%)
        >img
            width: 80px
            height: 80px
            margin-right: 20px

        .center
            display: inline-block
            width: calc(100% - 100px)
            .each
                display: inline-block
                width: 33.333333%
                font-weight: 400
                height: 40px
                border-left: 1px solid #fff
                text-align: center
                font-size: 16px
                margin-top: 20px
                > span
                    position: relative
                    top: -5px
                div
                    font-size: 24px
                    font-weight: 800
                    .small
                        font-size: 18px
    .charge-main
        text-align: center
        padding: 30px 30px 40px
        border: 1px solid #e9e9e9
        border-radius: 10px
        .text
            font-size: 18px
            font-weight: 600
            margin-bottom: 20px
        .charge-tr
            border: 1px solid #d4d4d4
            overflow: hidden
            min-width: 670px
            max-width: 800px
            margin: 0 auto 10px
            color: #666
            &.grey
                background: #f5f5f5
                margin-bottom: 0
            span
                font-size: 18px
                font-weight: 600
                line-height: 60px
            .charge-td
                border-right: 1px solid #d4d4d4
                width: 120px
                line-height: 30px
                background: #f5f5f5
                // float: left
                display: inline-block
                &.long
                    width: calc(50% - 120px)
                    background: #fff
                    color: #282729
                    text-align: left
                    padding-left: 20px
                &.no-br
                    border-right: none
</style>

<template lang="pug">
    div
        .p-title 充值
        .p-main
            .charge
                .home-fee
                    img.fl(src="../assets/home-icon-fee.png")
                    .center
                        .each
                            span 总余额
                            .els.Akrobat-ExtraBold
                                span.small ￥
                                span {{allFee | fmtFee}}
                                span.small .{{allFee | fmtFee(1)}}
                        .each
                            span 现金余额
                            .els.Akrobat-ExtraBold
                                span.small ￥
                                span {{cashFee | fmtFee}}
                                span.small .{{cashFee | fmtFee(1)}}
                        .each
                            span 赠款余额
                            .els.Akrobat-ExtraBold
                                span.small ￥
                                span {{giveFee | fmtFee}}
                                span.small .{{giveFee | fmtFee(1)}}

                .charge-main
                    .text 现金转账充值
                    .charge-tr
                        .charge-td 开户名称
                        .charge-td.long {{info.name}}
                        .charge-td 开户银行
                        .charge-td.long.no-br {{info.bankName}}
                    .charge-tr
                        .charge-td 银行账户
                        .charge-td.long {{info.bankNo}}
                        .charge-td 联系电话
                        .charge-td.long.no-br {{info.tel}}
                    .charge-tr(style="text-align: left;")
                        .charge-td(style="text-align: center;") 联系微信
                        .charge-td.long(style="border-right: none;") {{info.wx}}
                    .charge-tr.grey
                        span 充值前，请先咨询客服（24小时在线客服）

</template>

<script>
export default {
    name: 'recharge',
    data(){
        return {
            nums: {},
            money: 0,
            info: {}
        }
    },
    computed: {
        balanceInfo () {
            return this.$store.state.customer.balanceInfo
        },
        allFee () {
            return this.balanceInfo.balance || 0
        },
        cashFee () {
            return this.balanceInfo.cash || 0
        },
        giveFee () {
            return this.balanceInfo.give || 0
        }
    },
    created () {
        this.$store.dispatch('customer/getAccBalance') // 账户余额
        this.getInfo()
    },
    methods: {
        async getInfo() {
            let res = await this.fetch('/boss/common/config/v2/getDicValue', {code: '9001'}, 'get')
            if(res && res.code == this.successCode){
                try {
                    this.info = JSON.parse(res.data || '{}')
                }catch(e){}
            }
        }
    }
}
</script>

